import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { UpgradePlanPromotionalBanner } from '../upgrade-plan-promotional-banner/upgrade-plan-promotional-banner';
import { messages } from './messages';
import { useRateViewerContext } from './rate-viewer-context-provider';
import { RateViewerHeader } from './rate-viewer-header';
import { AllRatesView } from './views/all-rates-view';
import { CarriersView } from './views/carriers-view';
import { RateViewerView } from './views/rate-viewer-view';

import style from './new-rate-viewer.module.less';

export const NewRateViewer = () => {
  const { selectedView, selectedRate, configureLabel } = useRateViewerContext();

  const isAllRatesView = selectedView === RateViewerView.AllRates;

  const upgradePlanPromotionalBannerClassName = classnames(style['upgrade-plan-promotional-banner'], {
    [style['all-rates-view-upgrade-banner']]: isAllRatesView,
    [style['carriers-view-upgrade-banner']]: !isAllRatesView,
  });

  return (
    <div className={style['rate-viewer']}>
      <RateViewerHeader />
      <div className={style['rate-viewer-body']}>
        <UpgradePlanPromotionalBanner
          className={upgradePlanPromotionalBannerClassName}
          promotionalHeaderMessage={messages.upgradePromotionalBannerTitle}
        />
        {isAllRatesView ? <AllRatesView /> : <CarriersView />}
      </div>
      <div className={style['rate-viewer-footer']}>
        <Button
          className={style['configure-label-button']}
          disabled={!selectedRate}
          onClick={configureLabel}
          testId='configure-label-button'
          theme='primary'
        >
          <FormattedMessage {...messages.configureLabel} />
          <FontAwesomeIcon className={style['configure-label-icon']} icon={faArrowRight} />
        </Button>
      </div>
    </div>
  );
};
